module.exports =
  TEXT_NERDY_UK: 'TextNerdyUK'
